import React from 'react';

const EmojiIcon = ({ width = 24, height = 24, color = '#000' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.9925 1.5C4.8525 1.5 1.5 4.86 1.5 9C1.5 13.14 4.8525 16.5 8.9925 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 8.9925 1.5ZM9 15C5.685 15 3 12.315 3 9C3 5.685 5.685 3 9 3C12.315 3 15 5.685 15 9C15 12.315 12.315 15 9 15ZM12.75 7.125C12.75 7.7475 12.2475 8.25 11.625 8.25C11.0025 8.25 10.5 7.7475 10.5 7.125C10.5 6.5025 11.0025 6 11.625 6C12.2475 6 12.75 6.5025 12.75 7.125ZM6.375 8.25C6.9975 8.25 7.5 7.7475 7.5 7.125C7.5 6.5025 6.9975 6 6.375 6C5.7525 6 5.25 6.5025 5.25 7.125C5.25 7.7475 5.7525 8.25 6.375 8.25ZM12.5625 11.0625C11.85 12.2925 10.5225 13.125 9 13.125C7.4775 13.125 6.15 12.2925 5.4375 11.0625C5.295 10.815 5.4825 10.5 5.7675 10.5H12.2325C12.525 10.5 12.705 10.815 12.5625 11.0625Z"
      fill={color}
    />
  </svg>
);

export default EmojiIcon;
